export function AuthSplash({ message = 'Cargando…' }: { message?: string }) {
  return (
    <div className="grid min-h-screen place-items-center bg-surface">
      <div className="flex flex-col items-center gap-3 text-ink-muted">
        <div className="size-8 animate-spin rounded-full border-2 border-brand border-t-transparent" />
        <p className="text-sm">{message}</p>
      </div>
    </div>
  )
}
